module.exports = "/_next/static/images/expertiseDataCenters-5a5c307a3ff7091b9b16d1d875410df7.webp";